import styled from 'styled-components'

export const TableDiv = styled.div`
    border-radius:.25rem;
    font-size: 14px;
table{
    width: 100%;
}

table, th, td {
  border: 0.063rem solid var(--c5);
  border-collapse: collapse;
}

th,td{
    max-width: 16rem;
    padding: .5rem .75rem .5rem .75rem;
}

td{
    text-align: center;
}
    
td:first-child{
    width: 13%;
    text-align: center;
}

th{
    font-weight: bold;
}


thead > tr > th > div{
display: flex;
align-items: center;
justify-content: center;

svg{
    opacity: 0%;
}
}

tr:not(:first-child){
color: var(--a4);
}
`
